import React, { useState } from "react";
import { Container, Row, Col} from "react-bootstrap";
import OrbImage from "./assets/wheel.png";
import "./landing.css";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import BackgroundParticles from "../components/BackgroundParticles";

const Landing = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section style={{ position: "relative" }}  className="content-wrapper min-vh-100 d-flex align-items-center justify-content-center overflow-hidden">
      <BackgroundParticles />
      <Navbar />

      <Container
        fluid
        className="d-flex justify-content-center mt-4 align-items-lg-center"
        style={{ position: "relative" }}
      >
        <Row>
          {/* Left Text Content */}
          <Col md={8} className="text-center text-md-start mt-4">
            <br />
            <br />
            <span
              className="text-uppercase fw-semibold px-3 py-1 mt-4 rounded-pill"
              style={{
                color: "#d6299cff",
                backgroundColor: "rgba(59,130,246,0.1)",
                fontSize: "0.9rem",
              }}
            >
              #1 AI Development
            </span>

            <h2 className="fw-bold mt-4 text-dark display-5" style={{textTransform: "uppercase"}}>
            Building the Future with <br /> <span style={{color: "white", backgroundColor: "black"}}>Artificial Intelligence</span> <br /> 
             
            </h2>

            <p className="mt-4 text-dark fs-5" style={{ maxWidth: "400px" }}>
              Where Machines Learn to Think —<br /> and Businesses Learn to Scale
            </p>

            <div className="mt-4">
              <Link to="/contact"><button className="button-57">
                <span className="text">Talk  with our AI Expert ➜ </span>
                <span>Click here ➜ </span>
              </button></Link>
            </div>
          </Col>

          {/* Right Orb Image */}
          <Col
            md={4}
            className="d-flex justify-content-center mt-5 mt-md-0 position-relative"
          >
            {/* Gradient background */}
            <div
              className="orb-gradient"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: "400px",
                height: "300px",
                borderRadius: "50%",
                background:
                  "radial-gradient(circle at center, #ed90ceff, #b988d3ff)",
                transform: "translate(-50%, -50%)",
              
                filter: "blur(20px)", // soft glow
              }}
            ></div>
            {/* Orb Image */}
            <img
              src={OrbImage}
              alt="Blockchain Orb"
              className="img-fluid drop-shadow-2xl animate-orb"
              style={{ maxWidth: "500px", position: "relative", zIndex: 1 }}
            />
          </Col>
        </Row>
      </Container>

  

      {/* Custom CSS */}
      <style>{`
        @keyframes orbRotate {
          0% { transform: rotate(0deg) translateY(0px); }
          50% { transform: rotate(180deg) translateY(-15px); }
          100% { transform: rotate(360deg) translateY(0px); }
        }
        .animate-orb {
          animation: orbRotate 20s infinite linear;
        }

        /* Modal Styles */
        .custom-modal {
          background-color: #1c1c1c;
          border-radius: 12px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.8);
          padding: 20px;
        }
        .custom-header {
          border-bottom: 1px solid rgba(255,255,255,0.1);
        }
        .custom-input {
          background-color: #121212;
          border: 1px solid rgba(255,255,255,0.2);
          color: #fff;
        }
        .custom-input:focus {
          background-color: #121212;
          border-color: #d6299c;
          box-shadow: 0 0 5px rgba(214,41,156,0.5);
          color: #fff;
        }
        .custom-btn {
          background: linear-gradient(90deg, #d6299c, #5e068e);
          border: none;
          font-weight: 600;
          padding: 12px;
        }
        .custom-btn:hover {
          opacity: 0.9;
        }
      `}</style>
    </section>
  );
};

export default Landing;
